import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import PostsReducer, {toggleMenu} from './reducers/PostsReducer';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import todoReducers from './reducers/Reducers';
import { currentYearUIDReducer } from './reducers/currentYearUIDReducer';
import { uidReducer } from './reducers/uidReducer';
import serializeDetailReducer from './reducers/serializeDetailReducer';
import eventReducer from '../store/reducers/eventReducer';
import schoolReducer from '../store/reducers/schoolReducer';
import { logoReducer } from '../store/reducers/logoReducer';
import paymentReducer from './reducers/paymentReducer';
import payCheckReducers from './reducers/payCheckReducers';
import currentYearPaidReducer from './reducers/currentYearPaidReducer';
//import { reducer as reduxFormReducer } from 'redux-form';
const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    sideMenu: toggleMenu,
    posts: PostsReducer,
    auth: AuthReducer,
		todoReducers,
    currentYearUIDs: currentYearUIDReducer,
    existingUIDs: uidReducer,
    serializeDetail: serializeDetailReducer,
    events: eventReducer,
    schoolDetails: schoolReducer,
    logo: logoReducer,
    payment: paymentReducer,
    initialPending: payCheckReducers,
    currentYearPaid: currentYearPaidReducer,

});

//const store = createStore(rootReducers);

export const store = createStore(reducers,  composeEnhancers(middleware));

// export const store = createStore(rootReducer, applyMiddleware(thunk));
